import React, {useState} from 'react';
import {Input, Form} from "antd";
import {internalApi} from "../../common/axios";
import {DIALOG_KEY} from "../../shared/utils/enum";
import toast from "react-hot-toast";
import duration from 'dayjs/plugin/duration';
import dayjs from "dayjs";
import {buildUrl} from "../../shared/utils/net";
import {CancelButton, DeleteButton, SaveButton} from "../../shared/components/buttons/CustomButtons";
import {PackageManagerEntity} from "./PackageManagerEntity";

dayjs.extend(duration);

const PackageManagerEditModal = ({record, handleClose, dialogRef, handleSetDialog}) => {
    const [row, setRow] = useState(new PackageManagerEntity(record));

    const handleSetRows = (key, value) => {
        setRow((prevState) => {
            const newState = {...prevState};
            newState[key] = value;
            return new PackageManagerEntity(newState);
        });
    }

    const handleSave = async (e) => {
        e.preventDefault();

        if (row.isInvalidate()) return;

        await internalApi.post('manager/analysis/package', {data: [row.toJson()]}).then((res) => {
            toast.success(res.data.message);
            handleClose(true);
        }).catch((err) => {
            console.error(err);
            toast.error("저장 실패");
        });
        handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
    }

    const handleDelete = async (e) => {
        e.preventDefault();
        const currentDialog = dialogRef.current;  // ref에서 최신 상태 가져오기
        if (currentDialog.confirmText === 'DELETE') {
            await internalApi.delete(buildUrl('manager/analysis/package', {seq: row.seq})).then((res) => {
                toast.success(res.data.message);
                handleClose(true);
            }).catch((err) => {
                toast.error("삭제 실패");
                console.error(err);
            });

            handleSetDialog([{key: DIALOG_KEY.OPEN, value: false}, {key: DIALOG_KEY.CONFIRM_TEXT, value: ""}]);
        } else {
            toast.error("잘못된 확인 문자입니다. DELETE 를 입력하세요.");
            handleSetDialog([{key: DIALOG_KEY.CONFIRM_TEXT, value: ''}]);
        }
    }

    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: 26  }}>
                <Form layout="vertical">
                    <Form.Item label="패키지 ID">
                        <Input
                            name={"packageId"}
                            value={row.packageId}
                            onChange={e => handleSetRows('packageId', e.target.value)}
                            size="small"
                        />
                    </Form.Item>
                    <Form.Item label="패키지 이름">
                        <Input
                            name={"packageName"}
                            value={row.packageName}
                            onChange={e => handleSetRows('packageName', e.target.value)}
                            size="small"
                        />
                    </Form.Item>
                    <Form.Item label="가격">
                        <Input
                            name={"price"}
                            type="number"
                            value={row.price}
                            onChange={e => handleSetRows('price', e.target.value)}
                            size="small"
                        />
                    </Form.Item>
                    <Form.Item label="분류1">
                        <Input
                            name={"category1"}
                            value={row.category1}
                            onChange={e => handleSetRows('category1', e.target.value)}
                            size="small"
                        />
                    </Form.Item>
                    <Form.Item label="분류2">
                        <Input
                            name={"category2"}
                            value={row.category2}
                            onChange={e => handleSetRows('category2', e.target.value)}
                            size="small"
                        />
                    </Form.Item>
                </Form>
            </div>
            <div className={"event-edit-buttons"}>
                <SaveButton onClick={handleSave} handleSetDialog={handleSetDialog}/>
                <CancelButton onClick={handleClose}/>
                { row.seq > 0 &&
                    <DeleteButton onClick={handleDelete} handleSetDialog={handleSetDialog} display={true}/>
                }
            </div>
        </div>
    );
}

export default PackageManagerEditModal;
